import { mountWorldGlobe } from "./map/world-globe";
import { startRouter } from "./router";
import { registerServiceWorker } from "./pwa/register";
import { initSync } from "./state/sync";
import "./style.css";

const root = document.getElementById("app");
if (!root) {
  throw new Error("missing #app root element");
}

const globeLayer = document.createElement("div");
globeLayer.className = "globe-root";
root.appendChild(globeLayer);

const viewLayer = document.createElement("div");
viewLayer.className = "view-layer";
root.appendChild(viewLayer);

void (async () => {
  // Run sync in parallel with globe load — both are network-ish work,
  // and we want the merged cloud state in localStorage before any view
  // calls loadState().
  const [globe] = await Promise.all([mountWorldGlobe(globeLayer), initSync()]);
  startRouter(viewLayer, globe);
})();

registerServiceWorker();
